import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6e015a65&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pzuber/Desktop/Repozytoria/HairTalk/hairtalk/HairTalk/HT_Portal_VUE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VItem } from 'vuetify/lib'
import { VItemGroup } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VCol,VDivider,VIcon,VImg,VItem,VItemGroup,VMenu,VRow,VSheet,VSpacer,VSwitch})
